// src/components/LogoExports.js
import React from 'react';

// Icon-only logo with glow
export const DRAuraLogo = ({ size = 44 }) => (
  <img
    src="/assets/images/DR-Aura_SRF_2.png"
    alt="DR-Aura Icon"
    width={size}
    height={size}
    style={{ filter: 'drop-shadow(0 0 4px rgba(0, 120, 255, 0.6))' }}
    onError={(e) => { e.target.src = '/dr-logo-icon.png'; }}
  />
);

// Full-width logo with glow + float animation
export const DRAuraLogoFull = ({ height = 56 }) => (
  <img
    src="/assets/images/DR-Aura_SRF_1.png"
    alt="DR-Aura Full Logo"
    height={height}
    style={{
      objectFit: 'contain',
      animation: 'float 6s ease-in-out infinite',
      filter: 'drop-shadow(0 0 6px rgba(0, 120, 255, 0.6)) drop-shadow(0 0 12px rgba(0, 180, 255, 0.4))'
    }}
    onError={(e) => { e.target.src = '/dr-logo.png'; }}
  />
);